const linearCategories = (categories, options = []) => {
	for (let categry of categories) {
		options.push({
			value: categry._id,
			name: categry.name,
			slag: categry.slug,
			parentId: categry.parentId,
			type: categry.type
		});
		if (categry.children.length > 0) {
			linearCategories(categry.children, options);
		}
	}
	return options;
};

export default linearCategories;
